const ENV = process.env;

export default class ProductsService {
  static buyAction(paddleID, coupon, trackingTitle, successState) {
    let payload = {};
    const account = JSON.parse(localStorage.getItem('account'));

    if (paddleID === 507346) {
      payload = {
        product: paddleID,
        successCallback: function (data) {
          window.vm.$router.push({ name: successState, query: { checkout: data.checkout.id } });
          ga('send', 'event', 'Purchase Complete', 'Purchase', 'Purchase');
        },
        closeCallback: function () {
          ga('send', 'event', 'closedpaddlecheckout', 'closedcheckout', 'trackingTitle');
        },
      };
    } else {
      let passthrough = 'user_id=' + account.id;
      if (ENV.paddle_environment) {
        passthrough += '&environment=' + ENV.paddle_environment;
      }

      payload = {
        product: paddleID,
        passthrough: passthrough,
        email: account.email,
        marketingConsent: account.marketing_consent,
        successCallback: function (data) {
          window.vm.$router.push({ name: successState, query: { checkout: data.checkout.id } });
          ga('send', 'event', 'Purchase Complete', 'Purchase', 'Purchase');
        },
        closeCallback: function () {
          ga('send', 'event', 'closedpaddlecheckout', 'closedcheckout', 'trackingTitle');
        },
      };
    }
    if (coupon) {
      payload.coupon = coupon;
    }
    window.Paddle.Checkout.open(payload);
    ga('send', 'event', 'Initiate Checkout', 'Checkout', 'Initiate');
    ga('send', 'event', 'clickedbuy', 'initiatedcheckout', trackingTitle);
    window.fbq.push(['track', 'InitiateCheckout']);
  }

  static products() {
    const self = this;
    return [
      {
        name: 'Cinemagraph Pro for macOS',
        key: 'fcpmac',
        icon: 'https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png 1x',
        isPlan: false,
        urlScheme: 'cinemagraphpro',
        downloadUrl: '/products/mac/pro/download/',
        video: 'https://www.youtube.com/embed/GeG7kf1s8qc',
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(506277, coupon, 'Cinemagraph Pro for macOS', 'Mac-FCP-success');
          },
        },
      },
      {
        name: 'Persecond',
        key: 'fpsmac',
        icon: 'https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon.png 1x',
        isPlan: false,
        urlScheme: 'persecond',
        downloadUrl: '/products/mac/persecond/download/',
        video: 'https://www.youtube.com/embed/vy73FLTcv34',
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(537213, coupon, 'Persecond for macOS', 'mac-fps-license-success');
          },
        },
      },
      {
        name: 'Persecond for macOS Plan',
        key: 'fpsmac-month',
        icon: 'https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon.png 1x',
        isPlan: true,
        urlScheme: 'persecond',
        downloadUrl: '/products/mac/persecond/download/',
        video: 'https://www.youtube.com/embed/vy73FLTcv34',
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(537213, coupon, 'Persecond Plan Monthly', 'mac-fps-success');
          },
        },
      },
      {
        name: 'Persecond for macOS Plan',
        key: 'fpsmac-year',
        icon: 'https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon.png 1x',
        isPlan: true,
        isPersecond: true,
        urlScheme: 'persecond',
        downloadUrl: '/products/mac/persecond/download/',
        video: 'https://www.youtube.com/embed/vy73FLTcv34',
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(537212, coupon, 'Persecond Plan Yearly', 'mac-fps-success');
          },
        },
      },
      {
        name: 'Blendeo Plan',
        key: 'blendeo-month',
        icon: 'https://cdn.flixel.com/static/static-web/products/blendeo/blendeo@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/blendeo@1x.png 1x',
        isPlan: true,
        urlScheme: 'blendeo',
        downloadUrl: 'https://itunes.apple.com/app/cinemagraph-pro/id999411375?mt=8',
        video: 'https://www.youtube.com/embed/vy73FLTcv34',
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(552713, coupon, 'Blendeo Plan Monthly', 'blendeo-success');
          },
        },
      },
      {
        name: 'Blendeo Plan',
        key: 'blendeo-year',
        icon: 'https://cdn.flixel.com/static/static-web/products/blendeo/blendeo@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/blendeo@1x.png 1x',
        isPlan: true,
        isBlendeo: true,
        urlScheme: 'blendeo',
        downloadUrl: 'https://itunes.apple.com/app/cinemagraph-pro/id999411375?mt=8',
        video: 'https://www.youtube.com/embed/vy73FLTcv34',
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(552712, coupon, 'Blendeo Plan Yearly', 'blendeo-success');
          },
        },
      },
      {
        name: 'Cinemagraph Pro for iOS',
        key: 'fcpios',
        icon: 'https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon.png 1x',
        isPlan: false,
        urlScheme: '',
        downloadUrl: 'https://itunes.apple.com/app/cinemagraph-pro/id642139481?mt=8',
        video: 'https://www.youtube.com/embed/hS4GsrB3ePY',
        buy: {
          title: 'Download on the App Store',
          action: function () {
            window.location = 'https://appstore.com/cinemagraphpro';
            ga('send', 'event', 'clickedbuy', 'initiatedcheckout', 'Cinemagraph Pro for iOS');
            window.fbq.push(['track', 'InitiateCheckout']);
          },
        },
      },
      {
        name: 'Flixel Cloud Web+Apps',
        key: 'fcwa',
        isPlan: true,
        video: 'https://www.youtube.com/embed/GeG7kf1s8qc',
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(506279, coupon, 'Flixel Cloud Web+Apps', 'mac-fcwa-success');
          },
        },
      },
      {
        name: 'Flixel Cloud Web',
        key: 'fcw',
        isPlan: true,
        video: 'https://www.youtube.com/embed/GeG7kf1s8qc',
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(506478, coupon, 'Flixel Cloud Web', 'mac-fcw-success');
          },
        },
      },
      {
        // Mobile Plan - Yearly
        name: 'Mobile Plan',
        key: 'fmp-y',
        isPlan: true,
        video: 'https://www.youtube.com/embed/hS4GsrB3ePY',
        buy: {
          title: 'Buy Mobile',
          action: function (coupon) {
            self.buyAction(526021, coupon, 'Mobile Plan Yearly', 'mobile-success');
          },
        },
      },
      // Mobile Plan - Monthly
      {
        name: 'Mobile Plan',
        key: 'fmp-m',
        video: 'https://www.youtube.com/embed/hS4GsrB3ePY',
        buy: {
          title: 'Buy Mobile',
          action: function (coupon) {
            self.buyAction(529806, coupon, 'Mobile Plan Monthly', 'mobile-success');
          },
        },
      },
      {
        // Professional Plan - Yearly
        name: 'Professional Plan',
        key: 'fpp-y',
        isPlan: true,
        video: 'https://www.youtube.com/embed/GeG7kf1s8qc',
        buy: {
          title: 'Buy Professional',
          action: function (coupon) {
            self.buyAction(523574, coupon, 'Professional Plan Yearly', 'professional-success');
          },
        },
      },
      {
        // Professional Plan - Monthly
        name: 'Professional Plan',
        key: 'fpp-m',
        isPlan: true,
        video: 'https://www.youtube.com/embed/GeG7kf1s8qc',
        buy: {
          title: 'Buy Professional',
          action: function (coupon) {
            self.buyAction(529807, coupon, 'Professional Plan Monthly', 'professional-success');
          },
        },
      },
      {
        // Business Plan - Yearly
        name: 'Business Plan',
        key: 'fbp-y',
        isPlan: true,
        video: 'https://www.youtube.com/embed/GeG7kf1s8qc',
        buy: {
          title: 'Buy Business',
          action: function (coupon) {
            self.buyAction(523573, coupon, 'Business Plan Yearly', 'business-success');
          },
        },
      },
      {
        // Business Plan - Monthly
        name: 'Business Plan',
        key: 'fbp-m',
        isPlan: true,
        video: 'https://www.youtube.com/embed/GeG7kf1s8qc',
        buy: {
          title: 'Buy Business',
          action: function (coupon) {
            self.buyAction(529808, coupon, 'Business Plan Monthly', 'business-success');
          },
        },
      },
      {
        name: '7 Day Trial',
        key: 'weekTrial',
        isPlan: true,
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(518156, coupon, 'weekTrial', 'mac-fcwa-success');
          },
        },
      },
      {
        name: '30 day Trial',
        key: 'monthTrial',
        isPlan: true,
        buy: {
          title: 'Buy Now',
          action: function (coupon) {
            self.buyAction(518351, coupon, 'monthTrial', 'mac-fcwa-success');
          },
        },
      },
    ];
  }

  static productForKey(key) {
    return this.products().filter(function (elem) {
      return elem.key === key;
    })[0];
  }

  static orderDetails(hash, callback) {
    window.Paddle.Order.details(hash, function (data) {
      callback(data);
    });
  }

  static licenseKey(data) {
    return data.lockers[0].license_code;
  }

  static orderEmail(data) {
    return data.order.customer.email;
  }

  static activateUrl(urlScheme, data) {
    return urlScheme + ':///register?licenseCode=' + this.licenseKey(data) + '&email=' + this.orderEmail(data);
  }

  static conversionTracking(data) {
    ga('send', 'event', 'buysuccess', 'completedpurchase', data.checkout.title);
    ga('set', 'currencyCode', data.order.currency);
    ga('ec:addProduct', {
      id: data.order.product_id,
      name: data.checkout.title,
      price: data.order.total,
      quantity: 1,
    });
    ga('ec:setAction', 'purchase', {
      id: data.order.order_id,
      affiliation: 'Paddle',
      revenue: data.order.total,
    });
    window.fbq.push(['track', 'Purchase', {
      value: data.order.total,
      currency: data.order.currency,
    }]);
  }
}



// WEBPACK FOOTER //
// ./src/services/products.es6.js